import { setServiceActive, hasNextSlide, hasPrevSlide } from "./main";

(function () {
    jQuery(document).ready(function ($) {
        $('.services .next').on('click', function (e) {
            e.preventDefault();
            if (!hasNextSlide()) {
                let index = +$('.services .service.active').attr('data')
                let count = $('.service').length

                index < count && setServiceActive(index + 1)
            } else {
                $('.services .service.active .owl-carousel').trigger('next.owl.carousel');
            }
        });

        $('.services .prev').on('click', function (e) {
            e.preventDefault();
            if (!hasPrevSlide()) {
                let index = +$('.services .service.active').attr('data')

                index > 1 && setServiceActive(index - 1)
            } else {
                $('.services .service.active .owl-carousel').trigger('prev.owl.carousel');
            }
        });

        $('.service-carousel').owlCarousel({
            loop: false,
            dots: true,
            items: 1,
            mouseDrag: true,
            touchDrag: true,
            margin: 0,
            nav: true,
            navText: '',
            rewind: false,
            rewindNav: false,
        })
    })
})();
